var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5v2.352h-2.352v-2.352h2.352zM21 12.852v2.297h-2.352v-2.297h2.352zM23.352 22.148v-11.648h-9.352v2.352h2.352v2.297h-2.352v2.352h2.352v2.352h-2.352v2.297h9.352zM11.648 8.148v-2.297h-2.297v2.297h2.297zM11.648 12.852v-2.352h-2.297v2.352h2.297zM11.648 17.5v-2.352h-2.297v2.352h2.297zM11.648 22.148v-2.297h-2.297v2.297h2.297zM7 8.148v-2.297h-2.352v2.297h2.352zM7 12.852v-2.352h-2.352v2.352h2.352zM7 17.5v-2.352h-2.352v2.352h2.352zM7 22.148v-2.297h-2.352v2.297h2.352zM14 8.148h11.648v16.352h-23.297v-21h11.648v4.648z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.9f5c20336ef1b8375a17e7df3852d98a.svg";
export { ForwardRef as ReactComponent };